import { styled } from "goober";
import { PressButton } from "./PressButton";

export const Content = styled("div")`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 360px;
`;

export const TitleBlock = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Body = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const List = styled("div")`
  margin: 0;
  padding: 4px;
  border: 0.5px solid var(--border-alpha);
  border-radius: 12px;
  background: var(--surface-secondary);
  max-height: 240px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Row = styled(PressButton)`
  all: unset;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;
  min-width: 0;
  &:hover {
    background: var(--alpha4);
  }
`;

export const Footer = styled("div")`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
